export const filterOptions = {
  TODAY: 'TODAY',
  WEEK: 'WEEK',
  MONTH:'MONTH',
  LAST_WEEK: 'LASTWEEK',
  LAST_MONTH: 'LASTMONTH',
  DAY: 'DAY'
}
